import { useMutation } from '@tanstack/react-query'
import { createAlertForModule } from '../resources'

export function useCreateAlertForModuleMutation() {
  const mutation = useMutation({
    mutationFn: createAlertForModule,
  })

  return mutation
}
